export class ReferenceArea {
    id?: number;
    name: string;
    description: string;
    abbreviation: string;
    type: string;
    typeCode: string;
    latLongList?: string;
    area?: Area;
    projectId: number;
    stationCode: string;
}

export interface Position {
    latitude: string;
    longitude: string;
    altitude: string;
    valid: boolean;
}

export interface Center {
    latitude: string;
    longitude: string;
    altitude: number;
    valid: boolean;
}

export interface Area {
    positions: Position[];
    center?: Center;
}

